import React from "react";
import styled from "styled-components";

const ErrorWrap = styled.div`
  padding: 1rem 3rem;
  background-color: #ef5350;
  margin: 4rem 0 6rem;
`;

const ErrorTitle = styled.h3`
  color: white;
  font-size: 24px;
  font-weight: 400;
`;

const ErrorMessage = styled.p`
  font-size: 14px;
  color: white;
`;

const ErrorComponent = () => {
  return (
    <div className="container">
      <ErrorWrap>
        <ErrorTitle>Błąd - Nie udało się pobrać danych.</ErrorTitle>
        <ErrorMessage>
          Spróbuj odświeżyć stronę. Staramy się reagować najszybciej jak to
          możliwe. Prosimy o cierpliwość.
        </ErrorMessage>
      </ErrorWrap>
    </div>
  );
};

export default ErrorComponent;
